import repository from '@/repositories/Repository'

const resource = '/calendar'

export default {
  get() {
    return repository.bizoo.get(resource).then(r => r.data)
  },
}
